import { withInstall } from '@sgui-plus/utils/with-install'

import Scrollbar from './src/scrollbar.vue'

export const SgScrollbar = withInstall(Scrollbar)
export default SgScrollbar

export * from './src/util'
export * from './src/scrollbar'
export * from './src/thumb'
export * from './src/constants'
